import {TextareaHTMLAttributes, useEffect, useRef, useState} from "react"
import cx from "classnames"
import {useCalculateFitInput} from "hooks/useCalculateFitInput"
import styles from "./TextArea.module.css"

type Props = Omit<TextareaHTMLAttributes<any>, "onChange"> &
    Partial<{
        classNameWrap: string
        error: boolean
        fitContent: boolean
        onChange?: (value: string) => void
    }>

export function BaseTextArea(props: Props) {
    const {
        placeholder,
        disabled,
        value,
        rows = 5,
        className,
        onChange,
        maxLength,
        classNameWrap,
        error,
        fitContent,
        ...rest
    } = props
    const textareaRef = useRef(null)
    const {calculateTextareaMaxChars} = useCalculateFitInput()
    const [maxCharacters, setMaxCharacters] = useState<number>(undefined)

    useEffect(() => {
        if (fitContent && textareaRef.current) {
            const maxChars = calculateTextareaMaxChars(textareaRef.current)
            setMaxCharacters(maxChars)
        }
    }, [calculateTextareaMaxChars, fitContent])

    const onChangeValue = (event) => {
        onChange(event.target.value)
    }

    const textAreaClassName = cx(styles.input, className, {[styles.error]: error})
    const classNameWrapContainer = cx(styles.container, classNameWrap)

    return (
        <div className={classNameWrapContainer}>
            <textarea
                ref={textareaRef}
                rows={rows}
                className={textAreaClassName}
                onChange={onChangeValue}
                placeholder={placeholder}
                disabled={disabled}
                value={value}
                maxLength={fitContent && maxCharacters ? maxCharacters : maxLength}
                {...rest}
            />
            {!!maxLength && (
                <div className={styles.characterCount}>
                    {(value as string).length}/{maxLength}
                </div>
            )}
        </div>
    )
}
